import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import ControlledExpandableContainer from '../ControlledExpandableContainer/index.js';
import { genericMemo } from '../../utils/index.js';

function ExpandableContainer(props) {
  const {
    defaultVisibility = false,
    ...otherProps
  } = props;
  const [showContent, setContent] = useState(defaultVisibility ?? false);
  return /*#__PURE__*/React.createElement(ControlledExpandableContainer, _extends({}, otherProps, {
    name: undefined,
    expanded: showContent,
    onExpansionChange: setContent
  }));
}

var index = genericMemo(ExpandableContainer);

export { index as default };
//# sourceMappingURL=index.js.map
